import React from 'react';
import { Eye, CalendarClock } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../../../components/ui/dialog';
import { formatExpiry } from './documentConstants';

export const PreviewTemplateDialog = ({ open, onOpenChange, template }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Eye className="h-5 w-5 text-amber-500" />
          {template?.title}
        </DialogTitle>
        <DialogDescription className="sr-only"> dialog. Use the form below to continue.</DialogDescription>
      </DialogHeader>
      {template?.expires_in_days && (
        <div className="flex items-center gap-2 text-sm text-blue-600 bg-blue-50 px-3 py-2 rounded-lg">
          <CalendarClock className="h-4 w-4" />
          Expires {formatExpiry(template.expires_in_days)} after client acknowledgment
        </div>
      )}
      <div className="border-t pt-4">
        <div
          className="prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: template?.content || '' }}
        />
      </div>
    </DialogContent>
  </Dialog>
);
